import React, { useRef } from 'react';
import { Provider } from 'react-redux';
import Card from '../Card';
import { listingPerPageLimit } from '../../utils/constants';
import Pagination from '../Pagination';
import ListingFilters from '../ListingFilters';
import LoadingSpinner from '../LoadingSpinner';
import useAccommodationListing from './useAccommodationListing';

const AccommodationListing = () => {
  const ref = useRef(null);

  const {
    waiting,
    accommodations,
    error,
    setError,
    destinations,
    activeFilters,
    setActiveFilters,
    setSort,
    currentPage,
    setCurrentPage,
  } = useAccommodationListing(ref?.current?.parentNode?.dataset?.id);

  const renderCards = (items) => {
    if (items.length > 0) {
      return items.map((item) => (
        <Card payload={item} type="accommodation" key={`card--${item.id}`} />
      ));
    } else {
      return (
        <h5 className="c-holiday-finder__no-results">
          No results were found. Please alter you choice, or{' '}
          <a href="https://journeyscape-cms.wilddog.dev/contact/">
            get in touch
          </a>
        </h5>
      );
    }
  };

  try {
    if (error) {
      return <h1 className="e-h2">{error}</h1>;
    } else {
      if (waiting) {
        return <LoadingSpinner ref={ref} />;
      } else {
        const numberOfPages = Math.ceil(
          accommodations.length / listingPerPageLimit
        );

        let outputArray;

        if (accommodations.length > 16) {
          let startIndex = listingPerPageLimit * currentPage;
          startIndex = startIndex === Infinity ? 0 : startIndex;
          const endIndex = (currentPage + 1) * listingPerPageLimit;

          outputArray = accommodations.slice(startIndex, endIndex);
        } else {
          outputArray = accommodations;
        }

        return (
          <Provider store={window.store}>
            <div className="o-wrapper o-wrapper--wide">
              <div className="c-order">
                {destinations && destinations.length > 0 && (
                  <ListingFilters
                    destinations={destinations}
                    setter={(value) =>
                      setActiveFilters({ ...activeFilters, destination: value })
                    }
                    activeFilters={activeFilters}
                  />
                )}

                <div className="c-order__sort">
                  <div className="c-order__sort__field">
                    <label htmlFor="sort">Sort by:</label>

                    <select
                      name="sort"
                      id="sort"
                      onChange={({ target: { value } }) => setSort(value)}
                    >
                      <option value="popular">Most Popular</option>
                      <option value="new">New</option>
                      <option value="a-z">A - Z</option>
                      <option value="z-a">Z - A</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="c-cards u-py-2 u-py-4@tablet u-py-6@tablet-wide">
              <div className="o-wrapper o-wrapper--wide c-cards__body">
                {renderCards(outputArray)}
              </div>
            </div>

            <Pagination
              items={accommodations}
              numberOfPages={numberOfPages}
              setter={setCurrentPage}
              currentPage={currentPage}
            />
          </Provider>
        );
      }
    }
  } catch (error) {
    console.error(error);
    if (!error) setError('An unexpected error has occurred');
  }
};

export default AccommodationListing;
